import React, { Component } from "react";
import { connect } from 'react-redux';
import "./assets/hero.scss";
import helpmindlogo from "../header/assets/helpmindlogo.png";

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.session.isAuthenticated,
    showLoginPanel: state.root.showLoginPanel,
    user: state.session.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleLoginPanel: () => {
      //TODO:: this needs to go directly to a register model when done
      console.log('dispatching login panel show');
      dispatch({ type: 'SHOW_LOGIN_PANEL', loginTabActive: false });
    }
  }
}

class Hero extends Component {

  constructor(props) {
    super(props);
    //TODO: look into props.props.childProps, why not just props.childProps, or just props?
    this.childProps = props.props.childProps;
  }

  render() {
    const isAuthenticated = this.props.isAuthenticated;
    const user = this.props.user;

    //TODO:: tidy this up so not duplicating 
    if (this.childProps && this.childProps.header === 'standard') {
      const title = this.childProps.headerTitle;

      return (
        <div className="hero standard container-fluid">
          <div className="row">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-8 hero-content standard text-center align-middle">
                  <h1>{title}</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="hero container-fluid">
        <div className="row">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-8 hero-content text-center align-middle">
                <img className="logo" src={helpmindlogo} alt="help my mind" />
                {isAuthenticated && user &&
                  <div>
                    <h1>Hi {user.attributes.name}!</h1>
                    <p>Welcome back! How are you today?</p>
                  </div>
                }
                {!isAuthenticated &&
                  <div>
                    <h1>Helping you, to help yourself</h1>
                    <p>Be a part of our community</p>
                    <div className="row main-cta">
                      <a href="#" onClick={this.props.toggleLoginPanel}>join</a>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Hero);



// WEBPACK FOOTER //
// ./src/containers/header/Hero.js